<app-navbar />

<div class="container-fluid">
    <!-- Filtros -->
    <div class="card shadow-sm filtros-modernas border-0 mb-4">
        <div class="card-header d-flex align-items-center rounded-top">
            <i class="fas fa-search fs-5 me-2 text-white"></i>
            <h2 class="fw-bold">Controle de Ponto</h2>
        </div>
        <div class="card-body">
            <div class="row g-3 align-items-end">
                <div class="col-md-3">
                    <label class="form-label"><i class="bi bi-person"></i> Nome</label>
                    <select class="form-select" [(ngModel)]="filtroNome">
                        <option value="">Todos</option>
                        <option *ngFor="let nome of nomesUsuarios" [value]="nome">{{ nome }}</option>
                    </select>
                </div>

                <div class="col-md-3">
                    <label class="form-label"><i class="bi bi-calendar-event"></i> Data Início</label>
                    <input type="date" class="form-control" [(ngModel)]="filtroDataInicio" />
                </div>

                <div class="col-md-3">
                    <label class="form-label"><i class="bi bi-calendar-event"></i> Data Fim</label>
                    <input type="date" class="form-control" [(ngModel)]="filtroDataFim" />
                </div>

                <div class="col-md-3 d-flex gap-2">
                    <button class="btn btn-gradient-primary w-50" (click)="aplicarFiltro()">
                        <i class="bi bi-funnel-fill me-1"></i> Consultar
                    </button>
                    <button class="btn btn-warning w-50" (click)="resetarFiltro()">
                        <i class="bi bi-arrow-clockwise me-1"></i> Limpar
                    </button>
                </div>
            </div>
        </div>
    </div>



    <!-- Estados -->
    <div *ngIf="carregando" class="alert alert-info d-flex align-items-center gap-2">
        <i class="bi bi-hourglass-split"></i> Carregando registros...
    </div>
    <div *ngIf="erro" class="alert alert-danger d-flex align-items-center gap-2">
        <i class="bi bi-exclamation-triangle-fill"></i> {{ erro }}
    </div>
    <div *ngIf="!carregando && historicoFiltrado.length === 0"
        class="alert alert-warning d-flex align-items-center gap-2">
        <i class="bi bi-folder-x"></i> Nenhum ponto registrado no período.
    </div>

    <!-- Tabela -->
    <div class="table-responsive">
        <!-- Info de Filtro -->
        <div class="data-info mb-3 position-relative d-flex align-items-center">
            <i class="bi bi-calendar-event me-1 text-primary"></i>
            <span class="text-muted">
                Filtrando de <strong>{{ filtroDataInicioTexto }}</strong> até
                <strong>{{ filtroDataFimTexto }}</strong>
            </span>
            <!-- Ícone de exportação -->
            <button class="btn btn-icon-export ms-2 exportar" (click)="toggleExportMenu()" title="Exportar">
                <div class="download-wrapper" [class.animando]="exportIconAnimando" [class.ok]="exportIconOk">
                    <i *ngIf="!exportIconOk" class="bi bi-arrow-down download-seta"></i>
                    <div *ngIf="!exportIconOk" class="download-base"></div>
                    <i *ngIf="exportIconOk" class="bi bi-check-circle-fill download-ok"></i>
                </div>

            </button>

            <!-- Dropdown de exportação -->
            <div class="export-menu" *ngIf="exportMenuAberto">
                <button class="dropdown-item" (click)="exportarCSV(); toggleExportMenu()">
                    <i class="bi bi-file-earmark-spreadsheet me-1"></i> Exportar CSV
                </button>
                <button class="dropdown-item" (click)="exportarExcel(); toggleExportMenu()">
                    <i class="bi bi-file-earmark-excel me-1"></i> Exportar Excel
                </button>
            </div>
        </div>

        <!-- Tabela -->
        <table class="table table-bordered table-hover align-middle">
            <thead class="table-light">
                <tr>
                    <th>Nome</th>
                    <th>Data</th>
                    <th>Início</th>
                    <th>Pausa</th>
                    <th>Retorno</th>
                    <th>Fim</th>
                    <th>Total Horas</th>
                    <th colspan="2" class="text-center ">
                        <i class="bi bi-geo-alt-fill me-1"></i> Localização
                    </th>

                </tr>
            </thead>

            <tbody>
                <tr *ngFor="let ponto of historicoFiltrado; let i = index"
                    [ngClass]="{ 'linha-par': i % 2 === 0, 'linha-impar': i % 2 !== 0 }">
                    <td>{{ ponto.nome || 'Usuário N/A' }}</td>
                    <td class="expediente-data-cell">
                        <span class="expediente-data">
                            <i class="bi bi-calendar3 me-1 text-info"></i>
                            {{ ponto.inicioExpediente | date: 'dd/MM/yyyy' }}
                        </span>
                    </td>
                    <td>{{ formatarHora(ponto.inicioExpediente) }}</td>
                    <td>
                        <ng-container *ngIf="formatarHora(ponto.inicioPausa); else semDadosPausa">
                            {{ formatarHora(ponto.inicioPausa) }}
                        </ng-container>
                        <ng-template #semDadosPausa>
                            <span class="sem-dados-campo">Sem Dados</span>
                        </ng-template>
                    </td>
                    <td>
                        <ng-container *ngIf="formatarHora(ponto.retornoPausa); else semDadosRetorno">
                            {{ formatarHora(ponto.retornoPausa) }}
                        </ng-container>
                        <ng-template #semDadosRetorno>
                            <span class="sem-dados-campo">Sem Dados</span>
                        </ng-template>
                    </td>
                    <td>
                        <ng-container *ngIf="formatarHora(ponto.fimExpediente); else semDadosFim">
                            {{ formatarHora(ponto.fimExpediente) }}
                        </ng-container>
                        <ng-template #semDadosFim>
                            <span class="sem-dados-campo">Sem Dados</span>
                        </ng-template>
                    </td>
                    <td>{{ formatarHorasTrabalhadas(ponto.horasTrabalhadas) }}</td>
                    <td class="text-center">
                        <ng-container
                            *ngIf="formatarCoordenada(ponto.latitudeInicioExpediente) && formatarCoordenada(ponto.longitudeInicioExpediente); else noLocationStart">
                            <a [href]="'https://www.google.com/maps?q=' + formatarCoordenada(ponto.latitudeInicioExpediente) + ',' + formatarCoordenada(ponto.longitudeInicioExpediente)"
                                target="_blank" class="btn btn-location btn-start" title="Localização Início">
                                <i class="bi bi-signpost-2-fill"></i>
                            </a>
                        </ng-container>
                        <ng-template #noLocationStart>
                            <button type="button" class="btn btn-location btn-start"
                                (click)="informarSemCoordenada('início')" title="Sem localização">
                                <i class="bi bi-signpost-2-fill"></i>
                            </button>
                        </ng-template>
                    </td>
                    <td class="text-center">
                        <ng-container
                            *ngIf="formatarCoordenada(ponto.latitudeFimExpediente) && formatarCoordenada(ponto.longitudeFimExpediente); else noLocationEnd">
                            <a [href]="'https://www.google.com/maps?q=' + formatarCoordenada(ponto.latitudeFimExpediente) + ',' + formatarCoordenada(ponto.longitudeFimExpediente)"
                                target="_blank" class="btn btn-location btn-end" title="Localização Fim">
                                <i class="bi bi-flag-fill"></i>
                            </a>
                        </ng-container>
                        <ng-template #noLocationEnd>
                            <span class="btn btn-location btn-end sem-dados" title="Sem localização">
                                <i class="bi bi-x-circle text-danger"></i>
                            </span>
                        </ng-template>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>